import React, { useEffect, useState, useRef } from 'react'
import { SettingsIcon, LogoutAltIcon } from './Icons'
import { getAnchoredOverlayPosition } from './overlayPosition'

interface UserMenuProps {
    isOpen: boolean
    onClose: () => void
    anchorRef: React.RefObject<HTMLElement | null>
    onLogout: () => void
    onSettings: () => void
}

const UserMenu: React.FC<UserMenuProps> = ({
    isOpen, onClose, anchorRef, onLogout, onSettings
}) => {
    const menuRef = useRef<HTMLDivElement>(null);
    const [position, setPosition] = useState({ left: 0, top: 0 });

    useEffect(() => {
        if (isOpen && anchorRef.current && menuRef.current) {
            const rect = anchorRef.current.getBoundingClientRect();
            setPosition(getAnchoredOverlayPosition({
                anchorRect: rect,
                panelWidth: menuRef.current.offsetWidth,
                panelHeight: menuRef.current.offsetHeight,
            }));
        }
    }, [isOpen, anchorRef]);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target as Node) &&
                anchorRef.current &&
                !anchorRef.current.contains(event.target as Node)
            ) {
                onClose();
            }
        }
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose, anchorRef]);

    if (!isOpen) return null;
    return (
        <div
            ref={menuRef}
            className="fixed z-50 min-w-[200px] overflow-hidden rounded-2xl border border-secondary bg-surface p-2 shadow-2xl"
            style={{ left: position.left, top: position.top }}
        >
            <button
                onClick={() => {
                    onSettings();
                    onClose();
                }}
                className="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm font-medium text-content-secondary transition-colors hover:bg-hover hover:text-content"
            >
                <SettingsIcon padding={0} size={7} />
                Settings
            </button>
            <button
                onClick={() => {
                    onLogout();
                    onClose();
                }}
                className="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm font-medium text-content-secondary transition-colors hover:bg-hover hover:text-content"
            >
                <LogoutAltIcon padding={0} size={7} />
                Logout
            </button>
        </div>
    )
}

export default UserMenu
